export const en = {
  loginWith: 'Login with',
  approveWith: 'Approve with',
  signWith: 'Sign with',
  confirmWith: 'Confirm with',
  acceptWith: 'Accept with',
  sameDevice: 'On this device',
  anotherDevice: 'With your SSN',
  anotherDeviceQR: 'On another device',
  mitidBusiness: 'MitID Business',
  finnishMobileID: 'Finnish Mobile Certificate',
  finnishBankID: 'Finnish Bank ID',
  swedishBankID: 'Swedish BankID',
  norwegianBankID: 'Norwegian BankID',
  biometrics: 'Biometrics',
  openAndScan: 'Open the BankID app on your mobile device and scan the QR code.',
  thisIsTheQR: 'This is a BankID QR Code. You can click it to view it in full screen.',
  completingLogin: 'Completing your login.',
} as const;
